import classNames from 'classnames';
import parse from 'html-react-parser';

import useNavigationHandler from '../../../hooks/useNavigationHandler/useNavigationHandler';

import { TExhibition } from '../../../types/TGetExhibitionsResponse';

import placeholderImage from '../../../images/placeholder.jpg';

import commons from '../../../shared/styles/common.module.scss';
import styles from './ExhibitionItem.module.scss';

type TProps = {
  exhibition: TExhibition;
};

const ExhibitionItem = ({ exhibition }: TProps) => {
  const { createNavigationHandler } = useNavigationHandler();

  return (
    <div className={classNames(styles.exhibitionContainer, commons.container)}>
      <div className={styles.exhibitionContent}>
        <a
          key={exhibition.id}
          href={String(exhibition.id)}
          onClick={(e) => {
            e.preventDefault();
            createNavigationHandler(
              exhibition.id,
              'exhibitionPage',
              ':exhibitionId',
            );
          }}
          className={styles.exhibitionWrapper}>
          <div className={styles.exhibitionText}>
            <h4 className={styles.exhibitionTitle}>{exhibition.title}</h4>
            {Object.values(exhibition.dates).some((item) => item) && (
              <p className={styles.exhibitionDate}>
                <span>{exhibition.dates.start_date}</span>
                {exhibition.dates.end_date && (
                  <>
                    <span>-</span>
                    {exhibition.dates.end_date}
                  </>
                )}
              </p>
            )}
            <p className={styles.exhibitionExcerpt}>
              {parse(exhibition.excerpt)}
            </p>
          </div>
          <img
            src={exhibition.featured_image || placeholderImage}
            alt={exhibition.title}
            className={styles.exhibitionImage}
          />
        </a>
      </div>
    </div>
  );
};

export default ExhibitionItem;
